var map = {
	"./da/main.yml": 56,
	"./de/main.yml": 57,
	"./en/main.yml": 58,
	"./es/main.yml": 59,
	"./fr/main.yml": 60,
	"./gd/main.yml": 61,
	"./id/main.yml": 62,
	"./it/main.yml": 63,
	"./pt_BR/main.yml": 64,
	"./ru/main.yml": 65,
	"./tr/main.yml": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;